export default __webpack_public_path__ + "static/media/cart.43ad6591.svg";